import { type FC } from 'react';
import { type TextFieldProps } from '@mui/material/TextField';
import { RHFChipInput } from './rhf-chip-input';

export const PROFESSION_OPTIONS = [
  'Acupuncturist',
  'Athletic Trainer',
  'Ayurvedic Practitioner',
  'Chiropractor',
  'Coach (Health/Life)',
  'Counselor',
  'Dietitian',
  'Doctor (MD/DO)',
  'Doula',
  'Energy Healer',
  'Fitness Instructor',
  'Health Educator',
  'Herbalist',
  'Holistic Practitioner',
  'Manual Therapist',
  'Massage Therapist',
  'Meditation Teacher',
  'Mental Health Therapist',
  'Midwife',
  'Naturopath',
  'Nurse',
  'Nutritionist',
  'Occupational Therapist',
  'Osteopath',
  'Personal Trainer',
  'Physical Therapist',
  'Physiotherapist',
  'Pilates Instructor',
  'Psychologist',
  'Reiki Practitioner',
  'Sports Therapist',
  'Strength & Conditioning Coach',
  'Wellness Coach',
  'Yoga Teacher',
];

type TProps = Omit<TextFieldProps, 'name'> & {
  name: string;
};

export const RHFProfessionInput: FC<TProps> = props => (
  <RHFChipInput
    {...props}
    options={PROFESSION_OPTIONS}
    placeholder={props.placeholder ?? 'Select or add your profession(s)'}
  />
);
